module.exports = __webpack_public_path__ + "img/9V.6c1a09a5.png";